<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color:#2284ab">Intimation Letter</h5>
      </div>
      <div class="body-content">
        <b-row class="mb-2">
          <b-col md="6">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-form-group horizontal label="Sort" class="mb-0" label-size="sm">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
          show-empty
          head-variant="dark"
          stacked="md"
          bordered
          striped
          :items="form.UserApplication"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size:12px"
        >
          <template slot="downloadT" slot-scope="row">
            <a
              :href="'https://s3.ap-south-1.amazonaws.com/sgbimages/' + form.UserID +'/' + row.item.ApplicationNo +'_Physical_Exam_Call_Letter.pdf'"
              target="_blank"
              v-if="row.item.StatusID==4"
            >Download</a>
          </template>
          <template slot="downloadP" slot-scope="row">
            <a
              :href="'https://s3.ap-south-1.amazonaws.com/sgbimages/' + form.UserID +'/' + row.item.ApplicationNo +'_Police_Verification.pdf'"
              target="_blank"
              v-if="row.item.StatusID==14 || row.item.StatusID==24"
            >Download</a>
          </template>
          <template slot="downloadM" slot-scope="row">
            <a
              :href="'https://s3.ap-south-1.amazonaws.com/sgbimages/' + form.UserID +'/' + row.item.ApplicationNo +'_Medical_Certificate.pdf'"
              target="_blank"
              v-if="row.item.StatusID==14 || row.item.StatusID==24"
            >Download</a>
          </template>
          <template slot="uploads" slot-scope="row">
            <a
              :href="'/#/upload/' +row.item.UserApplicationID"
              v-if="row.item.StatusID==14 || row.item.StatusID==34 || row.item.StatusID==24"
            >Upload</a>
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import Print from "vue-print-nb";
import apis from "@/apis";
export default {
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      products: [],
      fields: [
        { key: "EventTitle", label: "Job Title", sortable: true },
        { key: "ApplicationNo", label: "Application No.", sortable: true },
        { key: "ApplicationDate", label: "Application Date", sortable: true },
        { key: "ApplicationStatus", label: "Status" },
        { key: "downloadT", label: "Physical Test" },
        { key: "downloadP", label: "Police Verification" },
        { key: "downloadM", label: "Medical Cert" },
        { key: "uploads", label: "Upload" },
        { key: "Comments", label: "Remarks" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedProductId: "",
      /*** */
      form: {
        UserID: "",
        FullName: "",
        Gender: true,
        DOB: "",
        Age: 0,
        EmailId: "",
        MobileNo: "",
        RegistrationType: 0,
        UserApplication: []
      }
      /*** */
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getImgUrl(item, filename) {
      return (
        "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
        this.form.UserID +
        "/" +
        item.ApplicationNo +
        "_" +
        filename +
        ".pdf"
      );
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    var UserId = userinfo.UserId;
    let promise = apis.getUserApplications(UserId);

    promise.then(response => {
      if (response.status == 200) {
        this.form = response.body[0];
      }
    });
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}

.reg-form-box .btn {
  border-radius: 2px;
}

.reg-form-box {
  padding: 10px 10px;
}

.reg-form-box .reg-form-body {
  border: solid thin #e0e0e1;
  padding: 15px 25px;
  font-size: 11pt;
}

.reg-form-box .reg-form-body .col {
  padding: 10px 8px !important;
}

.reg-form-box .reg-form-body .form-control {
  font-size: 10pt !important;
  padding: 5px 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/IntimationLetter.vue